import {Injectable} from '@angular/core';
import {Helper} from '../../helpers/helper.service';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class ExportService {
  constructor(private helper: Helper, private http: HttpClient) {
  }

  generateExcelFile(exportType) {
    return this.http.post<any>(environment.apiUrl + '/backoffice/export', exportType)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

}
